import request from '@/plugins/request';

/**
 * 获取字典数据列表
 * @param {Object} params - 请求参数
 * @param {string} params.dictType - 字典类型
 * @returns {Promise} - 返回Promise对象
 */
export function getDictDataList(params) {
  return request({
    url: '/fronted/dict/data/getList',
    method: 'get',
    params
  });
}

/**
 * 获取合作伙伴分类（高校/教授）
 * @returns {Promise} - 返回Promise对象
 */
export function getFriendsCategory() {
  return request({
    url: '/fronted/dict/data/getList',
    method: 'get',
    params: {
      dictType: 'friends_category'
    }
  });
}
